module.exports = __webpack_public_path__ + "static/img/Jack-White.b0b2447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-White.jpg
// module id = Ll9a
// module chunks = 1